import { SIGN_UP_TYPES } from './constants';

const initialState = {
  signupFormData: null,
  personalInfoFormData: null,
};

export const signupProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGN_UP_TYPES.PROCEED: {
      return {
        ...state,
        signupFormData: action.payload,
      };
    }

    case SIGN_UP_TYPES.PERSONAL_INFO_CHANGE: {
      return {
        ...state,
        personalInfoFormData: action.payload,
      };
    }

    case SIGN_UP_TYPES.RESET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/auth/signup/reducer.js